<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 no-padding">
          <div class="ui-block" ref="avatarUpload">
            <div class="top-header top-header-favorit mb-down" style="margin: 0 !important;">
              <div class="top-header-thumb" style="height: 200px;z-index: 0 !important;">
                <div class="top-header-thumb-overlay"></div>
                <img src="/image/298203.jpg" alt="nature" style="width:100%" />
                <div class="top-header-author">
                    <response-message :data="errorData" />
                  <div class="author-thumb" style="border-color: #0c5460">
                      <img v-if="isOtherUser === false" :src="getAvatarLocal()" class="user-avatar" @click="getImageProfile()">
                      <img v-else :src="getOtherAvatar()" class="user-avatar">
<!--                      <div v-if="isOtherUser === false" class="user-avatar" @click="getImageProfile()" :style="`background-image: url(${getAvatarLocal()})`"></div>-->
<!--                      <div v-else class="user-avatar" :style="`background-image: url(${getOtherAvatar()})`"></div>-->
                    <div class="upload_option" id="setVidible">
                      <img src="/image/lg.gooey-ball-lodaer.gif" style="padding:30px" />
                    </div>
                    <div v-if="isOtherUser === false" class="upload_option">
<!--                      <a href="javascript:;" class="btn btn-control bg-breez">-->
<!--                        <svg class="olymp-chat-&#45;&#45;messages-icon">-->
<!--                          <use xlink:href="/svg-icons/sprites/icons.svg#olymp-camera-icon" />-->
<!--                        </svg>-->
<!--                      </a>-->
                      <form enctype="multipart/form-data">
                        <input
                          type="file"
                          style="display:none"
                          id="getImageProfile"
                          @change="previewImage"
                          name="image"
                        />
                      </form>
                    </div>
                  </div>
                  <div class="author-content">
                    <router-link
                        v-if="isOtherUser === false"
                      :to="'/profile/' + $store.state.user.username"
                      class="h3 author-name"
                    >
                      {{ getLocalData().firstname === null || getLocalData().firstname === undefined ? getLocalData().username : getLocalData().firstname + ' ' + getLocalData().lastname }}
                    </router-link>
                    <a
                        v-else
                      href="javascript:;"
                      class="h3 author-name"
                    >
                      {{ firstname === null || firstname === undefined ? username : firstname + ' ' + lastname }}
                    </a>
                      <div class="country" v-if="isOtherUser === false">
                          {{ $store.state.user.club === '' ? 'No Club' : $store.state.user.club[0].team_name }}
                      </div>
                      <div class="country" v-else>
                          {{club}}
                      </div>


                  </div>
                </div>
              </div>


              <div class="profile-section" style="z-index: 0!important;">
                <div v-if="isOtherUser === false" class="control-block-button">
                  <a href="#" class="btn btn-control bg-mdd">
                    <svg class="olymp-chat---messages-icon">
                      <use xlink:href="/svg-icons/sprites/icons.svg#olymp-camera-icon" />
                    </svg>
                  </a>

                  <router-link :to="{name: 'AccountInfo'}" class="btn btn-control bg-purple">
                    <svg class="olymp-chat---messages-icon">
                      <use xlink:href="/svg-icons/sprites/icons.svg#olymp-settings-v2-icon" />
                    </svg>
                  </router-link>

                  <router-link :to="{name: 'PasswordChange'}" class="btn btn-control bg-orange d-sm-block d-md-none">
                    <svg class="olymp-chat---messages-icon">
                      <use xlink:href="/svg-icons/sprites/icons.svg#olymp-settings-v2-icon" />
                    </svg>
                  </router-link>

                </div>

                <div v-else class="control-block-button">
                  <span v-if="signedIn === true">
                    <button v-if="is_following === false" @click="connection()" class="btn btn-lg following" style="z-index: 0 !important;background-color: #fff;color:#000">Follow</button>
                    <button v-else @click="connection()" class="btn btn-lg unfollowing" style="z-index: 0 !important;background-color: #fff;color:#000">Unfollow</button>
                  </span>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <EditPictureModal :imgData="imgSrc" from="profile"></EditPictureModal>
  </div>
</template>

<script>
import { mapState } from "vuex";

import avta from "@/functions/getAvatar";
import ls from "../../localstorage";
import EditPictureModal from "./EditPictureModal";

var pageData = {
  projectName: "",
  userData: {},
  id: null,
  avatar: "",
  signedIn: false,
  errorData: {},
  isActive: false,
  isOtherUser: false,
  firstname: "",
  lastname: "",
  username: "",
  club: '',
  is_following: false,
  other_id: "",
    type: "",
  spinnerData: {},
  imgSrc: '',
};
export default {
  name: "ProfileBanner",
  data() {
    return pageData;
  },
  components: {
    EditPictureModal,
  },
  computed: mapState({
    getAvatar: state => state.user.avatar,
    getUsername: state => state.user.username,
    getUserDetails: state => state.user,
  }),
  mounted() {
    this.getUserData();
    this.checkUserData();
    window.eventBus.$on("isOtherUser", val => {
      // // console.log('other user ',val);
      this.getUserData();
      this.isOtherUser = val;
    })
      window.eventBus.$on('updateProfile', val => {
          this.updateProfile(val)
          $('.mod').addClass('d-none')
      })
  },
  methods: {
    showLoading(options = {}) {
      let loader = this.spinnerData = {
        spinner: 'Jumper',
        isLoading: options.show !== undefined ? options.show : true ,
        color: '#00bfff',
        size: '60px',
        options: 'center relative',
      };
      return loader;
    },
    getLocalData() {
        let userData = ls.getStorage("fansData");
        userData = userData[0];
        // console.log(userData)
        return userData;
    },
    getOtherAvatar() {
      return avta({ local: { av: this.avatar, us: this.username } });
    },
    getAvatarLocal() {
      return avta({ state: { av: this.getAvatar, us: this.getUsername } });
    },

      checkUserData() {
          if (ls.checkStorage("fansData")) {
            this.signedIn = true;
          }else {
            this.signedIn = false;
          }
      },

    // process following and is following
    connection() {
      if (this.$store.state.user.username !== undefined) {
        if (this.is_following === false ) {
          // process follow
          $(".following").attr("disabled",true);
          $(".following").html('...');
          this.axios.post('user/follow/' + this.other_id)
                  .then(response => {
                    // console.log(response.data);
                    this.is_following = true;
                    $(".following").attr("disabled",false);
                    $(".following").html('Unfollow');
                    return response;
                  })
                  .catch(error => {
                    // console.log(error.response);
                    $(".following").attr("disabled",false);
                    $(".following").html('Follow');
                    return error;
                  })
        }else {
          // process unfollow
          $(".unfollowing").attr("disabled",true);
          $(".unfollowing").html('...');
          this.axios.post('user/unfollow/' + this.other_id)
                  .then(response => {
                    // console.log(response.data);
                    this.is_following = false;
                    $(".unfollowing").attr("disabled",false);
                    $(".unfollowing").html('Follow');
                    return response;
                  })
                  .catch(error => {
                    // console.log(error.response);
                    $(".unfollowing").attr("disabled",false);
                    $(".unfollowing").html('Unfollow');
                    return error;
                  })
        }
      }else {
        $("#registration-login-form-popup").modal("show");
      }
    },
    // get other users data
    getUserData() {
      // let loader = this.showLoading();
      var usernameRoute = this.$route.params.username;
      let user;
      if (ls.checkStorage("fansData")) {
        let userData = ls.getStorage("fansData");
        user = userData[0].username;
      }else {
        user = '';
      }

      if (user !== usernameRoute && usernameRoute !== undefined) {
        this.isOtherUser = true;
        if (this.signedIn === false) {
            this.axios
                .get("/other/detailsout/" + usernameRoute + "/1")
                .then(response => {
                    // loader.hide();
                    var responseData = response.data.data;
                    // console.log('other user data',responseData);
                    this.username = responseData.username;
                    this.firstname = responseData.firstname;
                    this.lastname = responseData.lastname;
                    this.is_following = responseData.is_following;
                    this.other_id = responseData.id;
                    this.club = responseData.club;
                    this.type = responseData.type;
                    if (responseData.avatar === undefined) {
                        this.avatar = responseData.logo;
                    }else {
                        this.avatar = responseData.avatar;
                    }
                })
                .catch(error => {
                    // loader.hide();
                    //   // console.log(error);
                    return error;
                });
        }else {
            this.axios
                .get("/other/detailsin/" + usernameRoute + "/1")
                .then(response => {
                    // loader.hide();
                    var responseData = response.data.data;
                    // console.log('other user data',responseData);
                    this.username = responseData.username;
                    this.club = responseData.club;
                    this.firstname = responseData.firstname;
                    this.lastname = responseData.lastname;
                    this.is_following = responseData.is_following;
                    this.other_id = responseData.id;
                    this.type = responseData.type;
                    if (responseData.avatar === undefined) {
                        this.avatar = responseData.logo;
                    }else {
                        this.avatar = responseData.avatar;
                    }
                })
                .catch(error => {
                    // loader.hide();
                    //   // console.log(error);
                    return error;
                });
        }
      }else {
        // loader.hide();
        this.isOtherUser = false;
      }

    },

    showReview(review) {
      window.eventBus.$emit("reviews", review);
      $(".bll").removeClass("active");
      $(this).addClass("active");
      this.isActive = !this.isActive;
    },
    // click the image input form
    getImageProfile() {
      $("#getImageProfile").click();
    },
      humanFileSize(size) {
          var i = Math.floor( Math.log(size) / Math.log(1024) );
          return ( size / Math.pow(1024, i) ).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
      },
      // convert blob to image file
      blobToFile(theBlob, fileName){
          //A Blob() is almost a File() - it's just missing the two properties below which we will add
          theBlob.lastModifiedDate = new Date();
          theBlob.name = fileName;
          return theBlob;
      },
    // update user avatar
    async previewImage() {
        this.errorData = {};
        let file = $("#getImageProfile").get(0).files;
        let fileSingle = $("#getImageProfile").get(0).files[0];
        if(fileSingle.size > 2049819 || fileSingle.size > 2049819 ) {
            this.errorData = {
                message: "Sorry only files less than 2 MB",
                isError: true,
            };
        }else {
            if (file.length > 0) {
                if (
                    fileSingle.name.split(".")
                        .pop() !== "png" &&
                    fileSingle.name.split(".")
                        .pop() !== "jpg" &&
                    fileSingle.name.split(".")
                        .pop() !== "jpeg"
                ) {
                    this.errorData = {
                        message: "Sorry image can only be (Jpg - Png)",
                        isError: true,
                    };
                } else {
                    const imageSrc = fileSingle
                    // this.updateProfile();
                    if (typeof FileReader === 'function') {
                      const reader = new FileReader();

                      reader.onload = (event) => {
                        // console.log(event)
                        this.imgSrc = event.target.result;
                        // rebuild cropperjs with the updated source
                        $('.mod').removeClass('d-none')
                      };

                      reader.readAsDataURL(imageSrc);
                    } else {
                      console.log('Sorry we just faced an error')
                    }

                }
            }
        }
    },
      updateProfile(data) {
        $('#setVidible').css('visibility','visible')
          // let file = $("#getImageProfile").get(0).files[0];
          let formData = new FormData();
          formData.append('image', data.blob);
          this.axios({
              method: "post",
              url: "/profile/update",
              data: formData,
              config: { headers: { "Content-Type": "multipart/form-data" } },
          })
          .then(response => {
              $('#setVidible').css('visibility','hidden')
              this.showLoading({show:false})
              this.fetchUserDetails();
              this.errorData = {
                  message: "Image Uploaded",
                  isError: "success",
              };
              // here we manupulate the dom for user experience
              // we temporarily change the state so for the image to show in real-time
              // const userData = this.getUserDetails
              this.$store.state.user.avatar = data.imageUri

              return response;
          })
          .catch(error => {
              $('#setVidible').css('visibility','hidden')
              this.errorData = {
                  message: error.response
                      ? "An error from our end"
                      : "Sorry an error occured, check your internet",
                  isError: true,
              };
          });
      },
      fetchUserDetails() {
          // request to load user data
          window.eventBus.$emit("loadUserData", true);
      },
  }
};
</script>

<style>
.top-header-author .author-thumb {
  position: relative !important;
    cursor: pointer;
}
.upload_option {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  z-index: 5;
  top: 0;
  border-radius: 50%;
  transition: all 0.3s ease-in;
}
/*.top-header-author .author-thumb:hover .upload_option {*/
/*  visibility: visible;*/
/*}*/
.profile-menu li {
  cursor: pointer;
}
.profile-menu .active {
  color: black;
  font-weight: bold;
}
.author-thumb .user-avatar {
    width: 100% !important;
    height: 100% !important;
    background-repeat: no-repeat;
    background-position: center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    overflow: hidden;
}
.author-thumb {
    border-radius: 100%;
    border: 6px solid #fff;
    margin: 0 auto;
    overflow: hidden;
    width: 132px;
    height: 132px;
    background-color: #FDFBEE; }
/* @media (max-width: 980px) {
  .mb-down {
    margin: 70px 0 0 0 !important;
  }
} */
@media (max-width: 680px) {
  .mb-down .user-avatar {
    width: 100%;
    height: auto !important;
  }
  .mb-down .top-header-author .author-thumb {
    width: 99px;
    height: 99px;
  }
}
@media (max-width: 490px) {
  .mb-down .top-header-author .author-thumb {
    width: 69px;
    height: 69px;
  }
}
    .ui-block {
        border:none !important;
    }
</style>
